import { render, staticRenderFns } from "./countrySnapshotContent.vue?vue&type=template&id=0f740590&scoped=true"
import script from "./countrySnapshotContent.vue?vue&type=script&lang=js"
export * from "./countrySnapshotContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f740590",
  null
  
)

export default component.exports